import { getApiClient } from "./apiRegistry";

/**
 * @deprecated Use getApiClient().get<T>(path) instead
 */
export function APIGetRequest<T>(path: string): Promise<T> {
  return getApiClient().get<T>(path);
}

/**
 * @deprecated Use getApiClient().post<T>(path, body) instead
 */
export function APIPostRequest<T>(path: string, body: unknown): Promise<T> {
  return getApiClient().post<T>(path, body);
}

/**
 * @deprecated Use getApiClient().patch<T>(path, body) instead
 */
export function APIPatchRequest<T>(path: string, body: unknown): Promise<T> {
  return getApiClient().patch<T>(path, body);
}

/**
 * @deprecated Use getApiClient().put<T>(path, body) instead
 */
export function APIPutRequest<T>(path: string, body: unknown): Promise<T> {
  return getApiClient().put<T>(path, body);
}

/**
 * @deprecated Use getApiClient().del<T>(path, body) instead
 */
export function APIDeleteRequest<T>(path: string, body: unknown): Promise<T> {
  return getApiClient().del<T>(path, body);
}
